import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { AltShortcutProvider } from '../contexts/AltShortcutContext';

const SystemAdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user is system admin
  if (!user.is_system_admin) {
    // Redirect tenant users to their tenant dashboard
    if (user.tenant_subdomain) {
      return <Navigate to={`/app/${user.tenant_subdomain}/dashboard`} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return <AltShortcutProvider>{children}</AltShortcutProvider>;
};

export default SystemAdminRoute;




